import { Col, Menu, Row, Tag, notification } from "antd";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../../assets/css/omessage.css";
import { useVoiceContext } from "../../../voice/context/VoiceContext";

import SubAccountsListing from "../../../pages/subAccount/SubAccountsListing";
import { UpgradeAlertPopup } from "../../../pages/utils/CommonVessels";
import { getCurrentFeature } from "../../../voice/utils/VoiceUtils";
import HSelect from "../../custom/input/select/Select";
import {
  Chargebee_PLAN_NAME_MONTHLY,
  Chargebee_PLAN_NAME_MONTHLY_OLD,
  Chargebee_PLAN_NAME_YEARLY,
  Chargebee_PLAN_NAME_YEARLY_OLD,
  VOICE_CHARGEBEE_PLAN_MONTHLY,
  VOICE_CHARGEBEE_PLAN_YEARLY,
} from "./../../../constants/AppConstants";
import { AppContext } from "./../../../context/AppContext";
import SideBarCredits from "./SideBarCredits";
import SideBarSupportBooking from "./SideBarSupportBooking";
import "../../../assets/css/get-started.css";
import { Grid } from "antd";

export default function SideBarMenuItem(props) {
  const [api, contextHolder] = notification.useNotification();
  const { toggleSidebar, handleNavigation, setAccessDenied } = props;
  const location = useLocation();
  const [appProperties] = useContext(AppContext);
  // Track which menu items are open
  const [subMenuOpenKeys, setSubMenuOpenKeys] = useState([]);
  // Track whether messaging or voice was last opened
  const [sideBarBorderShow, setSideBarBorderShow] = useState(false);
  const [queryParams, setQueryParams] = useState(null);
  const [upgradeAlertPopup, setUpgradeAlertPopup] = useState(false);
  const [callProperties, setCallProperties] = useVoiceContext();
  const [selectedKeys, setSelectedKeys] = useState([window.location.pathname]);
  const isAutomationEnabled = useMemo(() => {
    return !appProperties?.controller?.sideBarExtend?.hideAutomationSideBar;
  }, [appProperties?.controller?.sideBarExtend?.hideAutomationSideBar]);
  const isVoiceEnabled = useMemo(() => {
    return !appProperties?.controller?.sideBarExtend?.hideVoiceSideBar;
  }, [appProperties?.controller?.sideBarExtend?.hideVoiceSideBar]);
  const showCredits = useMemo(() => {
    return appProperties?.savedNumbers?.filter((obj) => obj?.isHelloSendPhoneNumber === "true")?.length > 0 ? true : false;
  }, [appProperties?.savedNumbers]);
  const [creditsAccessibleForMobile, setCreditsAccessibleForMobile] = useState(false);
  const { md: isMediumViewport } = Grid.useBreakpoint();

  useEffect(() => {
    if (selectedKeys.length > 0 && setAccessDenied) {
      setAccessDenied(false);
    }
  }, [selectedKeys, setAccessDenied]);

  useEffect(() => {
    if (appProperties?.osyncId) {
      appProperties?.controller?.getUrlParamsForRedirection(true, appProperties).then(function (queryParamsFromApp) {
        setQueryParams(queryParamsFromApp);
      });
      if (!appProperties?.controller?.isCreditAccessible) return;
      appProperties?.controller
        ?.isCreditAccessible()
        .then((isCreditAccessible) => setCreditsAccessibleForMobile(isCreditAccessible))
        .catch(() => {
          setCreditsAccessibleForMobile(false);
        });
    }
  }, [appProperties, appProperties?.osyncId]);
  const callStateOptions = [
    { value: " ", label: "Inbound" },
    { value: "idle", label: "Idle" },
    { value: "answered", label: " Answered" },
    { value: "ringing", label: "Ringing" },
    { value: "save-close", label: "Save and CLose" },
  ];
  const handleStatusOnChange = (value) => {
    let mockData = {
      incomingCallTo: "+13512136494",
      recordId: "3885812000080914067",
      recordLink: "https://crm.zoho.com/crm/org685955847/tab/Contacts/3885812000080914067",
      module: "Contacts",
      avatar: "https://img.freepik.com/premium-photo/natural-beauty-portrait-woman-autumn-forest_1351942-2475.jpg",
      lastName: "Sophia Carter",
      phone: "+12562861007",
    };

    setCallProperties((prev) => ({
      ...prev,
      isDialPadVisible: true,
      callStatus: value,
      callMockData: mockData,
      incomingCall: value === " ",
    }));
  };
  var locationHref = window.location.origin;
  const topItems = useMemo(
    () =>
      [
        appProperties?.agencyAccount &&
          !isMediumViewport && {
            key: "subAccount",
          },
        {
          key: "inbox",
          label: "Inbox",
          icon: <span data-cy="inbox-sidebar" className="actionIconsSprite2-small inboxIcon d-block"></span>,
          path: "/inbox",
          dataCy: "left-side-bar-inbox-link",
        },
        appProperties?.controller?.contactsEnabled && {
          key: "contacts",
          label: "Contacts",
          icon: <span className="actionIconsSprite2-small contactsIcon d-block"></span>,
          path: "/contacts",
        },
        {
          key: "messaging",
          label: "Messaging",
          icon: <span className="actionIconsSprite2-small messaging-icon d-block"></span>,
          dataCy: "left-side-bar-messaging-link",
          children: [
            {
              key: "campaigns",
              parentKey: "messaging",
              label: "Campaign",
              path: "/messaging/campaigns/list",
              icon: <span className="actionIconsSprite2-small campaign-icon d-block"></span>,
              dataCy: "left-side-bar-messaging-campaign-link",
            },
            isAutomationEnabled && {
              key: "automation",
              parentKey: "messaging",
              label: "Automation",
              icon: <span className="actionIconsSprite2-small automation-icon d-block"></span>,
              sub_children: [
                {
                  key: "workflow",
                  parentKey: "automation",
                  label: "Webhook",
                  path: "/messaging/automation",
                  icon: <span className="actionIconsSprite2-small webhook-icon d-block"></span>,
                  dataCy: "left-side-bar-messaging-automation-webhook-link",
                },
              ],
            },
            {
              key: "logs",
              parentKey: "messaging",
              label: "Message Logs",
              path: "/messaging/logs",
              // Only show for admin (roleId 12) and account-owner (roleId 11)
              hidden: ![11, 12].includes(appProperties?.currentUser?.roleId),
              icon: <span className="actionIconsSprite2-small message-logs-icon d-block"></span>,
              dataCy: "left-side-bar-messaging-logs-link",
            },
          ].filter(Boolean),
        },
        isVoiceEnabled && {
          key: "voice",
          label: (
            <div className="d-flex flex-row">
              <div>Call</div>
            </div>
          ),
          icon: <span className="actionIconsSprite2-small voice-side-bar-icon display-inline-block"></span>,
          dataCy: "left-side-bar-voice-link",
          children: [
            {
              key: "callFlow",
              parentKey: "voice",
              label: "Call Flow",
              path: "/voice/callFlow/list",
              icon: <span className="actionIconsSprite2-small call-flow-icon d-block"></span>,
              dataCy: "left-side-bar-voice-callflow-link",
            },
            {
              key: "history",
              parentKey: "voice",
              label: "Call History",
              path: "/voice/history",
              icon: <span className="actionIconsSprite2-small call-history-icon d-block"></span>,
              dataCy: "left-side-bar-voice-history-link",
            }
          ],
        },
        {
          key: "settings",
          label: "Settings",
          icon: <span data-cy="settings-sidebar" className="actionIconsSprite2-small settingIcon display-inline-block"></span>,
          path: "/settings",
          dataCy: "left-side-bar-settings-link",
        },
        appProperties?.isAutoSuggestionEnabled && {
          key: "ai",
          label: "AI",
          icon: <span className="actionIconsSprite2-small aiIcon d-block"></span>,
          children: [
            {
              key: "data-sources",
              parentKey: "ai",
              label: "Data Sources",
              path: "/ai/data-sources",
              icon: <span className="actionIconsSprite2-small aiDataSourcesIcon d-block"></span>,
            },
            {
              key: "playground",
              parentKey: "ai",
              label: "Playground",
              path: "/ai/playground",
              icon: <span className="actionIconsSprite2-small aiPlaygroundIcon d-block"></span>,
            }
          ]
        },
        appProperties?.controller?.contactsEnabled && {
          key: "get-started",
          label: "Get Started",
          icon: <span className="actionIconsSprite2-small get-started-icon d-block"></span>,
          path: "/get-started",
        },
        // !appProperties?.hideChannels && {
        //   key: "channels",
        //   label: "Channels",
        //   icon: <span className="actionIconsSprite2-small channelsIcon display-inline-block"></span>,
        //   path: "/channels",
        //   settingsSidebarAboveSpace: "100px",

        // },
      ].filter(Boolean),
    [appProperties?.agencyAccount, appProperties?.currentUser?.roleId, isVoiceEnabled, isAutomationEnabled,isMediumViewport,appProperties?.controller?.contactsEnabled,]
  );
  const bottomItems = useMemo(
    () =>
      [
        showCredits && {
          key: "credits",
          label: "Check Balance",
          supportBody: "Credits",
          class: `creditsBalance supportBook lh-2 ${creditsAccessibleForMobile ? "" : "d-none"}`,
          type: "credits",
        },
        {
          key: "support",
          label: " ",
          description: "Chat with us",
          class: "supportBook pt-1 border-0 bg-white",
          type: "custom",
          onClick: () => {
            if (window.$zoho && window.$zoho.salesiq) {
              window.$zoho.salesiq.floatwindow.visible("show");
            }
          },
        },
        // {
        //   key: "bookAgent",
        //   label: "Support",
        //   description: "Book Agent",
        //   class: "supportBook pt-1 border-0 bg-white",
        //   icon: <span className="actionIconsSprite2-small bookAgentIcon display-inline-block"></span>,
        //   type: "popup",
        //   iframeUrl: HELLOSEND_BOOOKING_URL,
        // },
      ].filter(Boolean),
    [creditsAccessibleForMobile, showCredits]
  );
  const getSelectedAndOpenKeys = () => {
    let selectedKey = "";
    let subMenuOpenKey = [];

    const pathSegments = location.pathname.split("/");
    const pathSegment = pathSegments[1];
    const moduleName = pathSegments[2];

    const menuItems = [...topItems, ...bottomItems];

    menuItems.forEach((item) => {
      // Normal path matching
      if (pathSegment === item.key) {
        if (pathSegment === "messaging" || pathSegment === "voice" || pathSegment === "ai" ) {
          if (moduleName !== "automation") {
            selectedKey = moduleName;
            subMenuOpenKey.push(item.key);
          } else {
            selectedKey = "workflow";
            subMenuOpenKey.push("messaging", "automation");
          }
        } else {
          selectedKey = item.key;
        }
      } else if (item.children) {
        item.children.forEach((child) => {
          if (pathSegment === child?.key) {
            selectedKey = child?.key;
            subMenuOpenKey.push(item.key);
          }
        });
      }
    });

    return { selectedKey, subMenuOpenKey };
  };

  const { selectedKey, subMenuOpenKey } = getSelectedAndOpenKeys();

  useEffect(() => {
    setSelectedKeys([selectedKey]);
    setSubMenuOpenKeys(subMenuOpenKey);
  }, [bottomItems, location, topItems, selectedKey]);

  const generateMenuItems = (menuItems) => {
    let updatedSearch = "?" + queryParams?.toString();
    return menuItems.map((item) => {
      if (item.key === "subAccount") {
        return {
          key: item.key,
          label: (
            <div className={`${sideBarBorderShow ? "px-3 py-2" : "px-1 d-md-none"}`}>
              <SubAccountsListing
                closeOffCanvas={() => toggleSidebar()}
                selectComponentWidth={sideBarBorderShow ? "90%" : "94%"}
                selectComponentHeight={sideBarBorderShow ? 50 : 60}
              />
            </div>
          ),
        };
      }

      if (item.children) {
        return {
          key: item.key,
          label: (
            <Row className="hs-max-w-130-px" align="middle">
              <Col span={5}>{item.icon}</Col>
              <Col span={19} className="interFontWeightMedium">
                {item.label}
              </Col>
            </Row>
          ),
          className: `sidebar-menu-child ${
            getCurrentFeature(appProperties) === "Message" && item?.key === "voice"
              ? "show-crown-icon"
              : getCurrentFeature(appProperties) === "Call" && item?.key === "messaging"
              ? "show-crown-icon"
              : ""
          }`,
          children: item.children
            .filter((child) => !child.hidden)
            .map((child) => {
              if (child.sub_children) {
                return {
                  key: child.key,
                  label: (
                    <Row className="hs-max-w-130-px" align="middle">
                      <Col span={5}>{child.icon}</Col>
                      <Col span={19} className="interFontWeightMedium">
                        {child.label}
                      </Col>
                    </Row>
                  ),
                  className: "ms-auto hs-w-93-6 sidebar-menu-sub-child",
                  children: child.sub_children.map((subChild) => ({
                    key: subChild.key,
                    label: (
                      <Link
                        to={subChild.path + updatedSearch}
                        target={sideBarBorderShow ? "_blank" : "_self"}
                        className="sidebar-link"
                        onClick={handleNavigation}
                      >
                        <Row className="hs-max-w-130-px" align="middle">
                          <Col span={5}>{subChild.icon}</Col>
                          <Col span={14} className="interFontWeightMedium">
                            {subChild.label}
                          </Col>
                        </Row>
                      </Link>
                    ),
                    className: "ps-3 hs-w-89 ms-auto",
                    "data-cy": subChild.dataCy,
                  })),
                };
              }

              return {
                key: child.key,
                label: (
                  <Link
                    to={child.path + updatedSearch}
                    target={sideBarBorderShow ? "_blank" : "_self"}
                    className="sidebar-link"
                    onClick={handleNavigation}
                  >
                    <Row className="hs-max-w-130-px" align="middle">
                      <Col span={5}>{child.icon}</Col>
                      <Col span={14} className="interFontWeightMedium">
                        {child.label}
                      </Col>
                    </Row>
                  </Link>
                ),
                className: "ms-auto hs-w-89 ps-2",
                "data-cy": child.dataCy,
              };
            }),
        };
      }

      return {
        key: item.key,
        label:
          item?.type === "popup" ? (
            <SideBarSupportBooking item={item} appProperties={appProperties} />
          ) : item?.type === "credits" ? (
            <SideBarCredits />
          ) : item?.type === "custom" ? (
            <Row className="hs-max-w-130-px" align="middle">
              <Col span={5}>{item.icon}</Col>
              <Col span={19} className="interFontWeightMedium">
                {item.label}
              </Col>
            </Row>
          ) : (
            <Link
              to={item.path + updatedSearch}
              className="sidebar-link mb-3"
              target={sideBarBorderShow ? "_blank" : "_self"}
              onClick={handleNavigation}
            >
              <Row className="hs-max-w-130-px" align="middle">
                <Col span={5}>{item.icon}</Col>
                <Col span={19} className="interFontWeightMedium">
                  {item.label}
                  {item?.key === "get-started" &&
                    !location.pathname.includes("/get-started") &&
                    (!appProperties?.hasContacts || !appProperties?.serviceInstalled) && (
                      <div className="position-absolute" style={{ right: "-18px", top: "-7px" }}>
                        <div className="hs-active-violet-strobe-container">
                          <div className="hs-active-violet-strobe-container-inner-small"></div>
                        </div>
                      </div>
                    )}
                </Col>
              </Row>
            </Link>
          ),
        className: item.class ?? "",
        "data-cy": item?.dataCy,
        onClick: (e) => {
          toggleSidebar();
          if (item?.type === "custom" && item.onClick) {
            item.onClick();
          }
        },
      };
    });
  };
  useEffect(() => {
    if (callProperties?.voicePlanRequestAccess) {
      const currentFeature = getCurrentFeature(appProperties);
      if (currentFeature) {
        api.open({
          message: `${currentFeature} Capability Enabled 🎉`,
          description: `Messaging and calling are now enabled for you. Start connecting with your customers effortlessly.`,
          showProgress: true,
          pauseOnHover: true,
        });

        setCallProperties((prev) => ({
          ...prev,
          voicePlanRequestAccess: false,
        }));
      }
    }
  }, [api, appProperties, setCallProperties, callProperties?.voicePlanRequestAccess]);

  useEffect(() => {
    if (props.sideBarCommonHandling) {
      setSideBarBorderShow(true);
    }
  }, [props.sideBarCommonHandling]);
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={`d-flex flex-column justify-content-between px-2 ${sideBarBorderShow ? "" : "sidebar-menuRightBorder"}`}
      style={{ height: "84vh", borderInlineEnd: 0 }}
    >
      {contextHolder}
      {queryParams && (
        <>
          <Menu
            className={`sidebar-menu border-end-0 w-100 ${sideBarBorderShow ? "sendSmsSideBar" : "sidebar-menuRightBorder"}`}
            mode={"inline"}
            openKeys={subMenuOpenKeys}
            onOpenChange={(e) => {
              if (
                Array.isArray(e) &&
                e.includes("messaging") &&
                [VOICE_CHARGEBEE_PLAN_MONTHLY, VOICE_CHARGEBEE_PLAN_YEARLY].includes(appProperties?.licenseObj?.licenseDetails?.planName)
              ) {
                setUpgradeAlertPopup(true);
              } else if (
                Array.isArray(e) &&
                e.includes("voice") &&
                [
                  Chargebee_PLAN_NAME_MONTHLY,
                  Chargebee_PLAN_NAME_YEARLY,
                  Chargebee_PLAN_NAME_YEARLY_OLD,
                  Chargebee_PLAN_NAME_MONTHLY_OLD,
                ].includes(appProperties?.licenseObj?.licenseDetails?.planName)
              ) {
                setUpgradeAlertPopup(true);
              } else {
                setSubMenuOpenKeys(e);
              }
            }}
            selectedKeys={selectedKeys}
            onSelect={({ key }) => setSelectedKeys([key])}
            items={generateMenuItems(topItems)}
          />
          <Menu
            className={`sideBarBottomMenu border-end-0 w-100 sidebar-menu ${sideBarBorderShow ? "sendSmsSideBar" : "sidebar-menuRightBorder"}`}
            mode={"inline"}
            selectedKeys={[selectedKey]}
            defaultOpenKeys={[subMenuOpenKey]}
            items={[
              ...generateMenuItems(bottomItems),
              ...(locationHref.indexOf("localhost") !== -1
                ? [
                    {
                      key: "callStatusSelect",
                      label: (
                        <HSelect
                          defaultValue={callProperties?.callStatus}
                          options={callStateOptions}
                          enableSearch={false}
                          customProps={{
                            className: "music-type-select typesOfPlayAudio w-100",
                            onChange: handleStatusOnChange,
                          }}
                          suffixIcon={<div className="call-action-icons callDropdownIcon" />}
                        />
                      ),
                    },
                  ]
                : []),
            ]}
          />

          {upgradeAlertPopup && <UpgradeAlertPopup upgradeAlertPopup={upgradeAlertPopup} setUpgradeAlertPopup={setUpgradeAlertPopup} />}
        </>
      )}
    </div>
  );
}
